import { render, staticRenderFns } from "./GiftAddToCartMobile.vue?vue&type=template&id=06d37d8c"
import script from "./GiftAddToCartMobile.vue?vue&type=script&lang=js"
export * from "./GiftAddToCartMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports